<template>
  <base-modal-component>
    <template v-slot:header>
      <h4 class="u-typography-color md-title">
        Identifier
      </h4>
    </template>

    <template v-slot:body>
      <p
        v-if="error && error.messages"
        class="md-error"
      >
        {{ error.messages }}
      </p>
      <form
        novalidate
        @submit.prevent="validateForm"
      >
        <div class="c-config-input-type">
          <md-field :class="getValidationClass($v.item.identifier)">
            <label for="identifier">ID</label>
            <md-input
              v-model.trim="item.identifier"
              v-focus
              required
              name="identifier"
              type="text"
              class="md-input"
              autocomplete="off"
            />
            <span
              v-if="!$v.item.identifier.required"
              class="md-error"
            >ID is required</span>
            <span
              v-else-if="!$v.item.identifier.isUnique"
              class="md-error"
            >ID already exists</span>
          </md-field>
          <error-response-messages :field-name="'identifier'" />
        </div>
      </form>
    </template>
    <template v-slot:footer>
      <div class="u-mr-xs">
        <generic-button
          variation="grey"
          @click="close"
        >
          Close
        </generic-button>
      </div>
      <generic-button
        variation="red"
        @click="validateForm"
      >
        Continue
      </generic-button>
    </template>
  </base-modal-component>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import GenericButton from '@/shared/buttons/GenericButton'
import ErrorResponseMessages from '@/shared/error-response-messages/ErrorResponseMessages'
import BaseModalComponent from '@/shared/modal/BaseModalComponent'
import { validationBaseMixin } from '@/mixins/ValidationBaseMixin'

export default {
  name: 'AddOrUpdateScopeIdentifier',
  components: {
    GenericButton,
    ErrorResponseMessages,
    BaseModalComponent
  },
  mixins: [validationBaseMixin],
  props: {
    item: {
      type: Object,
      required: true,
    },
    existingIdentifiers: {
      type: Array,
      default: () => [],
      required: false,
    },
    successFunction: {
      type: Function,
      required: true
    }
  },

  data() {
    return {
      messages: {
        error: null,
        success: null,
      },
    };
  },
  computed: {
    ...mapGetters("response", ["success", "error"]),
  },

  validations: {
    item: {
      identifier: {
        required,
        isUnique(value) {
          return !this.existingIdentifiers.includes((value || '').trim());
        },
      },
    },
  },

  methods: {
    ...mapActions("response", ["handleSuccess", "handleError", "resetError"]),

    validateForm () {
      if (typeof this.item.identifier === 'string') {
        this.item.identifier = this.item.identifier.trim();
      }

      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.successFunction(this.item);
        this.close();
      }
    },

    close() {
      this.$emit("close");
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
